module.exports = __webpack_public_path__ + "img/pink-shadow.4b445ec6.png";